import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { dobpcard, clock, mobileicon, insurance, dobb, syncbutton, syncbuttonsmall } from "./svgs";
import PatientTabs from "./patienttabs";
import api from "../../api/api";
import dayjs from "dayjs";
import OrderHistoryModal from "./orderhistorymodal";
import UpdateContactModal from "./updatecontact";
import { useSelector } from "react-redux";
import ToastMessage from "../../utils/mui/righttoptoast";
import { ChatIcon, GoogleIcon } from "../patientcharts/frames/svg";
import ConfirmReviewModal from "../patientcharts/frames/googleModal";
import ChatWrapper from "../../header/chat/chatwrapper";
import { getPracticeId, patientPhotoUrl, pcardShows, practiceFeatures } from "../../config/practice";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import NoteAltOutlinedIcon from "@mui/icons-material/NoteAltOutlined";
import { useStaffFormFill } from "../../forms/internal/launch";
import { useSendFormsWizard } from "../../forms/staff/launch";

const FALLBACK_AVATAR =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" fill="#EEF1F6"/><circle cx="32" cy="25" r="11" fill="#C3CBDA"/><path d="M8 62c0-13 11-21 24-21s24 8 24 21z" fill="#C3CBDA"/></svg>'
  );

export default function PcardPopup({ setPcard,refereshpcard,data, dob, isPcard }) {
  const practiseid = getPracticeId();

  const formattedDate = dayjs(dob || data?.dob).isValid()
    ? dayjs(dob || data?.dob).format("MM/DD/YYYY")
    : "-";

  const [appointmenthistory, setAppointmentHistory] = useState([]);
  const [chat,setChat]=useState(false)
  const [paymentshistory, setpaymentsHistory] = useState([]);
  const [visitsdata, setvisitsdata] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [issyncing,setIssyncing]=useState(false)
  const [toastSeverity, setToastSeverity] = useState("success");
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("appointments");
  const userConfig = useSelector((state) => state.userconfig);
  const [phonenumber, setPhonenumber] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [reviewtriggered, setReviewTriggered] = useState(false);
  // NEW: collapse/expand state for left rail
  const [collapsed, setCollapsed] = useState(false);
  // Form Wizard: the header's "Send forms" button (dev 6f44d95; was the rail icon).
  const [openSendForms, sendFormsWizard] = useSendFormsWizard();
  const showSendForms = practiceFeatures().formWizard && pcardShows("forms");
  // Internal staff forms: the header's "Staff form" button, right after "Send forms" (dev bf6e438; was the rail icon).
  const [openStaffForm, staffFormFill] = useStaffFormFill();
  const showStaffForm = practiceFeatures().staffForms && pcardShows("staffForms");

  const [openContactModal, setOpenContactModal] = useState(false);

const [selectedRiskAdjustment, setSelectedRiskAdjustment] = useState("");

const handleRiskAdjustmentChange = async (e) => {
  const value = e.target.value;

    try {
      setIsLoading(true);
      const response = await api.put(
        `/v1/${practiseid}/patient/${data?.patientid}/updateQualityRiskMetrics?quality_risk_metrics=${value}`
        
      );
      if (response.status === 200) {
          setSelectedRiskAdjustment(value);
          setToastMessage("Successfully updated");
          setToastSeverity("success");
          setOpenToast(true);
      } else {
        setToastMessage(
          response?.message || "Failed to update "
        );
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastMessage("Failed to update ");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAppointments = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/pcard/${data?.patientid}/get_patient_history`
      );
      if (response.status === 200) {
        setAppointmentHistory(response.data || []);
      } else {
        setAppointmentHistory([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleToastClose = () => setOpenToast(false);

  const handleSaveContact = async (newPhone) => {
    try {
      setIsLoading(true);
      const response = await api.put(
        `/v1/${practiseid}/pcard/patient/${data?.patientid}/department/${userConfig?.config?.departmentid}/patientinfoupdate`,
        {
          phone: newPhone,
          dob: dob,
        }
      );
      if (response.status === 200) {
        setPhonenumber(newPhone);
        setToastMessage("Contact information updated successfully");
        setToastSeverity("success");
        setOpenToast(true);
      } else {
        setToastMessage(
          response?.data?.message || "Failed to update contact information"
        );
        setToastSeverity("info");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastMessage(
        error?.response?.data?.message || "Failed to update contact information"
      );
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchvisits = async () => {
    try {
      const response = await api.get(
        `/v1/${practiseid}/appointments/${data?.patientid}/visits`
      );
      if (response.status === 200) {
        setvisitsdata(response.data || []);
      } else {
        setvisitsdata([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
const syncinsurance= async()=>{
try {
  setIssyncing(true)
  await api.post(`/v1/${practiseid}/patient/${data.patientid}/department/1/sync`)
  await api.post(`/v1/${practiseid}/patient/${data.patientid}/department/1/insurance-sync`)
} catch (error) {
  console.log(error)
}finally{
  refereshpcard()
  setIssyncing(false)
}
}
  const fetchPayments = async () => {
    try {
      setIsLoading(true);
      const response = await api.get(
        `/v1/${practiseid}/pcard/${data?.patientid}/getPaymentDetails`
      );
      if (response.status === 200) {
        setpaymentsHistory(response.data || []);
      } else {
        setpaymentsHistory([]);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data?.patientid && isPcard) fetchvisits();
  }, [data, isPcard]);

  useEffect(() => {
    if (data?.patientid && isPcard) {
      if (activeTab === "appointments") fetchAppointments();
      else fetchPayments();
    }
  }, [activeTab, data, isPcard]);
  const trigeerReview = async () => {
    // Call-notes practices (7825) never text a patient (the review link is an SMS).
    if (practiceFeatures().callNotes) return;
    try {
      setReviewTriggered(true);
      const response = await api.post(
        `/v1/${practiseid}/patient/${data?.patientid}/notification/google-review`
      );
      if (response.status === 200) {
        setToastSeverity("success");
        setToastMessage(response?.message || "Notification Sent Successfully");
        setOpenToast(true);
      } else {
        setToastSeverity("info");
        setToastMessage(response?.message || "something went wrong");
        setOpenToast(true);
      }
    } catch (error) {
      console.log(error);
      setToastSeverity("error");
      setToastMessage(error?.message || "something went wrong");
      setOpenToast(true);
    } finally {
      setReviewTriggered(false);
    }
  };
  if (!isPcard) return null;

  const patientName =
    `${data?.firstname || ""} ${data?.lastname || ""}`.trim() || "-";
  const patientPhone = phonenumber || data?.phone || data?.mobilephone || "";
  const lastVisit = visitsdata?.last_visit?.startdate
    ? dayjs(visitsdata.last_visit.startdate).format("MMM D, YYYY")
    : "-";
  const nextVisitAt = visitsdata?.next_visit?.startdate;
  const nextVisitTime = nextVisitAt ? dayjs(nextVisitAt).format("h:mm A") : "";
  const nextVisit = nextVisitAt
    ? `${dayjs(nextVisitAt).format("MMM D, YYYY")}${
        nextVisitTime && nextVisitTime !== "12:00 AM"
          ? ` \u00b7 ${nextVisitTime}`
          : ""
      }`
    : "-";

  // The strip cells under the header: one label over one value, hairline between.
  // Arbitrary values on purpose: Bootstrap's px-4/py-4 are !important and
  // would override the sm: step.
  const stripCell = "bg-white px-[16px] py-[24px] sm:px-[28px]";
  const stripLabel =
    "text-[11px] font-bold uppercase tracking-[0.9px] text-[#9AA4B5]";
  const stripValue = "mt-2 text-[15px] font-semibold text-[#14213D]";
  const headerBtn =
    "flex items-center gap-2 rounded-full border border-[#E3E8EF] bg-white px-4 py-2 text-[13px] font-semibold text-[#2c3357] hover:bg-[#F7F9FC]";
  const iconBtn =
    "flex h-9 w-9 items-center justify-center rounded-full border border-[#E3E8EF] bg-white hover:bg-[#F7F9FC] [&>svg]:h-4 [&>svg]:w-4";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#0B1220]/45 p-4 sm:p-6"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) setPcard(false);
      }}
    >
      {/* Below lg the whole popup scrolls as one page; from lg the header
          and strip stay put and the rail and tab content scroll on their own. */}
      <div className="relative flex max-h-[94vh] w-full max-w-[1480px] flex-col overflow-y-auto rounded-[20px] bg-white text-left shadow-[0_24px_70px_rgba(11,18,32,0.28)] lg:overflow-hidden">
        {/* Close sits in the corner at every width, so the action buttons can
            wrap under the name on narrow screens without taking it along. */}
        <div className="absolute right-3 top-3 z-10 sm:right-5 sm:top-[22px]">
          <IconButton
            aria-label="close"
            onClick={() => setPcard(false)}
            style={{ color: "#94A3B8" }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        {/* Header */}
        <div className="flex flex-none flex-col gap-4 px-[16px] pb-[20px] pr-[56px] pt-[20px] sm:px-[28px] sm:pr-[80px] sm:pt-[24px] lg:flex-row lg:pb-[48px] lg:items-start lg:justify-between lg:gap-6">
          <div className="flex min-w-0 items-start gap-4">
            <img
              className="h-[52px] w-[52px] flex-none rounded-[14px] sm:h-[64px] sm:w-[64px] object-cover ring-1 ring-[#E6EAF2]"
              alt={patientName}
              src={patientPhotoUrl(data?.patientid)}
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = FALLBACK_AVATAR;
              }}
            />
            <div className="min-w-0 pt-0.5">
              <div className="text-[11px] font-bold uppercase tracking-[1.1px] text-[#9AA4B5]">
                Patient card
              </div>
              <div className="mt-1 flex flex-wrap items-baseline gap-x-2.5">
                <h2 className="min-w-0 break-words text-[21px] font-bold leading-tight text-[#14213D] sm:text-[26px]">
                  {patientName}
                </h2>
                <span className="text-[15px] font-semibold text-[#9AA4B5]">
                  #{data?.patientid || "-"}
                </span>
              </div>
              <div className="mt-1.5 text-[13px] font-medium text-[#64748B]">
                DOB {formattedDate}
                {patientPhone ? (
                  <>
                    <span className="mx-2 text-[#CBD5E1]">&bull;</span>
                    {patientPhone}
                  </>
                ) : null}
              </div>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-2 lg:flex-none">
            {/* Google Review / Sync / Message / Send forms: gated per practice (pcardShows) */}
            {pcardShows("review") && (
            <button
              type="button"
              className={iconBtn}
              title="Google review"
              onClick={() => setShowPopup(true)}
            >
              {GoogleIcon}
            </button>
            )}
            {pcardShows("sync") && (
            <button
              type="button"
              className={iconBtn}
              title="Sync"
              onClick={() => refereshpcard()}
            >
              {syncbuttonsmall}
            </button>
            )}
            {pcardShows("chat") && (
            <button
              type="button"
              onClick={() => setChat(true)}
              className={headerBtn}
            >
              <span className="[&>svg]:h-4 [&>svg]:w-4">{ChatIcon}</span>
              Message
            </button>
            )}
            {showSendForms && (
            <button
              type="button"
              aria-label="Send forms"
              onClick={() => openSendForms(data, { dob })}
              className={headerBtn}
            >
              <PostAddOutlinedIcon sx={{ fontSize: 16 }} />
              Send forms
            </button>
            )}
            {showStaffForm && (
            <button
              type="button"
              aria-label="Staff form"
              onClick={() => openStaffForm(data, { dob })}
              className={headerBtn}
            >
              <NoteAltOutlinedIcon sx={{ fontSize: 16 }} />
              Staff form
            </button>
            )}
            <button
              type="button"
              onClick={() => setOpenContactModal(true)}
              className={headerBtn}
            >
              <span className="[&>svg]:h-4 [&>svg]:w-4">{dobb}</span>
              Update info
            </button>
          </div>
        </div>

        {/* Facts strip */}
        {/* Four across from lg, two from sm, stacked on phones; gap-px over a
            line-coloured background draws the hairlines in every arrangement. */}
        <div className={`grid flex-none grid-cols-1 gap-px border-y border-[#EDF1F7] bg-[#EDF1F7] sm:grid-cols-2 ${pcardShows("riskAdjustment") ? "lg:grid-cols-4" : "lg:grid-cols-3"}`}>
          <div className={stripCell}>
            <div className={stripLabel}>Insurance</div>
            <div className={`${stripValue} flex items-start gap-2`}>
              <span className="min-w-0">{data?.insurancename || "-"}</span>
              <button
                type="button"
                title="Sync insurance"
                className="mt-0.5 flex-none cursor-pointer"
                onClick={() => syncinsurance()}
              >
                {syncbuttonsmall}
              </button>
            </div>
          </div>

          <div className={stripCell}>
            <div className={stripLabel}>Last visit</div>
            <div className={stripValue}>{lastVisit}</div>
          </div>

          <div className={stripCell}>
            <div className={stripLabel}>Next visit</div>
            <div className={stripValue}>{nextVisit}</div>
          </div>

          {/* Risk Adjustments/Quality Measures: gated per practice */}
          {pcardShows("riskAdjustment") && (
          <div className={stripCell}>
            <div className={stripLabel}>Risk adjustment / quality measures</div>
            <select
              value={selectedRiskAdjustment}
              onChange={handleRiskAdjustmentChange}
              className="mt-1.5 w-full rounded-[10px] border border-[#E3E8EF] bg-white px-3 py-2 text-[14px] font-medium text-[#14213D] focus:outline-none focus:ring-2 focus:ring-[#1d2951]/20"
            >
              <option value="">None selected</option>
              <option value="ACO">ACO</option>
              <option value="WellMed">WellMed</option>
              <option value="United Healthcare">United Healthcare</option>
            </select>
          </div>
          )}
        </div>

        {/* Body: rail + content */}
        <div className="flex bg-[#F7F9FC] lg:min-h-0 lg:flex-1 lg:overflow-hidden">
          <PatientTabs
            activeTab={activeTab}
            data={data}
            setActiveTab={setActiveTab}
            isLoading={isLoading}
            paymentshistory={paymentshistory}
            appointmenthistory={appointmenthistory}
          />
        </div>

        {/* Modals & Toasts */}
        <UpdateContactModal
          open={openContactModal}
          onClose={() => setOpenContactModal(false)}
          phone={data.phone}
          onSave={handleSaveContact}
        />
        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
        <ConfirmReviewModal
          isOpen={showPopup}
          onClose={() => setShowPopup(false)}
          onConfirm={() => {
            trigeerReview();
            setShowPopup(false);
          }}
        />
        {chat ? (
          <ChatWrapper
            setChat={setChat}
            patientdata={data}
            flow={"comment"}
            top={"0px"}
          />
        ) : (
          <></>
        )}
        {sendFormsWizard}
        {staffFormFill}
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          }}
          open={isLoading || reviewtriggered || issyncing}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}
